import React, { useEffect, useState } from 'react';
import { Box, Dialog, DialogContent, Typography } from '@mui/material';
import { ReactComponent as UserProfile } from 'assets/img/svg/userProfile.svg';
import closeIcon from 'assets/img/svg/closeSquare.svg'
import { endpoint } from '../../../common/constant';
import { fetchAllPromisedData } from '../../../common/utils/methods/commonMethods/utilityMethod';
import CustomLoader from '../../../common/commonComponents/Loader/loader';
import { getFormatedDate } from '../../concessionApproval/common';


const HistoryPopup = ({
    open,
    setOpen,
    // paymentModeId,
    // processTagId,
    allActiveRoles
}) => {

    const [historyData, setHistoryData] = useState([]);
    const [loading, setLoading] = useState(false);

    const paymentModeId = open?.paymentModeId;
    const processTagId = open?.processTagTypeMasterId;

    useEffect(() => {
        const fetchHistoryData = async () => {
            try {
                setLoading(true);
                const resp = await fetchAllPromisedData(`${endpoint.paymentMode.processAndRoleMapping.getAuditByPaymentModeIdAndProcessId}?paymentModeMasterId=${paymentModeId}&processTagTypeMasterId=${processTagId}`)
                setHistoryData(resp);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        }

        paymentModeId && processTagId && fetchHistoryData();

    }, [paymentModeId, processTagId])

    return (
        <Dialog open={!!open}>
            <DialogContent style={{ padding: '0px', overflowX: 'hidden' }} >
                <Box className='concession-approval-dialog-content' width={500}>
                    <Box className='approval-dialog-header'>
                        {/* <Typography variant='h6'>Status</Typography> */}
                        <div style={{ fontWeight: 600, fontSize: '20px' }}>History</div>
                        <div onClick={() => setOpen(null)}><img src={closeIcon} /></div>
                    </Box>
                    {loading && <CustomLoader />}
                    {
                        !loading && historyData && historyData?.map(el => {
                            let role = allActiveRoles?.find(role => role?.id === el?.roleId)?.roleName;
                            return (
                                <Box className='user-remarks-details d-flex'>
                                    <UserProfile style={{ flexShrink: 0, marginRight: '3px' }} />
                                    <Box className='user-remarks'>
                                        <div style={{ fontSize: '16px', fontWeight: 600, color: "#0F0F0F", marginBottom: '3px' }}>{`${role} ${el?.isDeleted ? 'deleted' : 'added'}`}</div>
                                        {/* <div style={{ fontSize: '14px', fontWeight: 400, color: "#0F0F0F", marginBottom: '3px', wordBreak: 'break-word', paddingRight: '3px' }}>{"-"}</div> */}
                                        <div style={{ fontSize: '12px', fontWeight: 400, color: "#757575", marginBottom: '3px' }}>{`${el.updatedBy}| ${getFormatedDate(el?.updatedOn, true)}`}</div>
                                    </Box>
                                </Box>) 
                        })}
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default HistoryPopup;